import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
interface Property {
  type?: string;
}
/** Structured repeated observations remain JSON in form state but are edited through named fields. */
export function StructuredArrayField({
  id,
  value,
  onChange,
  properties,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  properties: Record<string, Property>;
}) {
  let rows: Record<string, unknown>[] = [];
  try {
    const parsed = JSON.parse(value || '[]');
    if (Array.isArray(parsed)) rows = parsed;
  } catch {
    /* legacy invalid text is retained until an explicit field edit */
  }
  const update = (next: Record<string, unknown>[]) => onChange(next.length ? JSON.stringify(next) : '');
  return (
    <div className="flex flex-col gap-3">
      {rows.map((row, index) => (
        <div key={index} className="rounded border p-3">
          <div className="grid gap-3 sm:grid-cols-2">
            {Object.entries(properties).map(([key, schema]) => (
              <Field key={key}>
                <FieldLabel htmlFor={`${id}-${index}-${key}`}>{key.replaceAll('_', ' ')}</FieldLabel>
                <Input
                  id={`${id}-${index}-${key}`}
                  className="min-h-11"
                  type={schema.type === 'number' || schema.type === 'integer' ? 'number' : 'text'}
                  value={String(row[key] ?? '')}
                  onChange={(e) => {
                    const v = e.target.value;
                    const updated = { ...row };
                    if (v === '') delete updated[key];
                    else updated[key] = schema.type === 'number' || schema.type === 'integer' ? Number(v) : v;
                    update(rows.map((r, i) => (i === index ? updated : r)));
                  }}
                />
              </Field>
            ))}
          </div>
          <Button
            type="button"
            variant="outline"
            className="min-h-11 mt-3"
            onClick={() => update(rows.filter((_, i) => i !== index))}>
            Remove row
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" className="min-h-11 self-start" onClick={() => update([...rows, {}])}>
        Add row
      </Button>
    </div>
  );
}
